import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { DataService } from './data.service';
import { UiAction } from "../models/omc.types";

@Injectable({
    providedIn: 'root'
})
export class UiActionsService {
    _uiActions: UiAction[] = null;
    private pendingRequest: Promise<UiAction[]> | null = null;

    constructor(private dataService: DataService) {}

    uiActions(force = false): Promise<any[]> {
        if (this._uiActions && !force) {
            // Returning cached data
            return Promise.resolve(this._uiActions);
        }

        if (!this.pendingRequest) {
            this.pendingRequest = this.dataService.getData('uiActionGroups', 'uiActionGroups', force)
                .then((data: any[]) => {
                    this._uiActions = data.reduce((prev, cur) => [...prev, ...cur.actions], []);
                    return this._uiActions;
                })
                .finally(() => {
                    this.pendingRequest = null;
                });
        }

        return this.pendingRequest;
    }

    getPermissionsForRoute(routeName, force) {
        return new Promise((resolve) => {
            this.uiActions(force).then((perms: Array<any>) => {
                let rtn = (perms || []).find((x) => x.routeName === routeName);
                if (!rtn) {
                    console.log('No permissions for ' + routeName);
                }
                resolve(rtn);
            });
        });
    }

    getPermissionsForName(permissionName: string, force = false): Promise<UiAction> {
        return this.uiActions(force).then((perms: UiAction[]) =>
            (perms || []).find(x => x.name === permissionName)
        );
    }
}

angular.module('omc').factory('uiActionsService', downgradeInjectable(UiActionsService));
